import clsx from 'clsx'
import React from 'react'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

export * from './label-value-row'

export interface RowProps extends ClassName {
  children?: React.ReactNode
  shouldSpaceBetween?: boolean
  showBottomBorder?: boolean
  showTopBorder?: boolean
  variant?: 'lined' | 'dotted'
}

export const Row = ({
  children,
  className,
  shouldSpaceBetween = true,
  showBottomBorder = false,
  showTopBorder = true,
  variant = 'lined'
}: RowProps) => (
  <div
    className={clsx(classes.row, className, {
      [classes.topBorder]: showTopBorder,
      [classes.bottomBorder]: showBottomBorder,
      'flex-space-between': shouldSpaceBetween,
      [classes.dotted]: variant === 'dotted'
    })}
  >
    {children}
  </div>
)
